"use strict";


/**
* Генератор форм.
*
* @example
* var form = new WebAccess.components.forms.FormBuilder("uniq_id");
* var form_html = form.addInput("ERR_ELEMENT_DOES_NOT_EXIST")
*                     .addInput("NOT_CREATED_SESSION_MANAGER")
*                     .addInput("EDOCUMENT_SIGN")
*                     .addText("NO_RIGHTS_FOR_SIGN_EDOC_DUE_EDIT")
*                     .addTextarea("REPORT_ASKABLE_PARAMS")
*                     .addInput("NOT_CREATED_SESSION_MANAGER")
*                     .render();
* WebAccess.current.sideBar.tabs.FldTree.setHtml(form_html);

* @example
* var CP = WA.components;
* var form = new CP.forms.FormBuilder("filter_save_modal");
*   form.addPick("FILTER_NAME", {"key": "value", "key2": "value2"}, null, null, true, {"isRequired": true});

* var dialog = new CP.dialogs.BaseDialog();
*   dialog.title = L("SAVE_NEW_FILTER");
*   dialog.html = form.render();
*   dialog.isShowCancelButton = true;
*   dialog.ok = function() {
*     if (form.isValid() === false) return false;
*     var filterName = form.getValue("FILTER_NAME");
*     var displayValue = form.getDisplayValue("FILTER_NAME");
*     if (filterName === "") {
*       CallService("/Service.asmx/CreateNewFilter", {"ReferenceCode": WA.current.getReferenceCode() ,"Name": displayValue} , function(response) {
*     });
*    }};
*   dialog.show();
*
* @since 5.0.0.4000
* @class WebAccess.components.forms.FormBuilder
* @mixes WebAccess.mixins.pluginMixin
* @extends BaseObject
* @param {string} id Уникальный идентификатор формы. Параметр является обязательным
* @property {string} displayErrors ["tip","inline", "none"] - режим отображения ошибок, возникающих при проверке корректности заполнения формы
* @throws ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED - заданы не все обязатаельные параметры.
*/

/**
 * Правила корректности заполнения формы.
 * @typedef {Object}  WebAccess.components.forms.FormBuilder.validatorRules
 * @property {boolean} [isRequired] Признак обязательного поля
 * @property {boolean} [isDate] Признак того, что поле имеет тип «Дата»: 01/01/2000, 01.01.2000, а не 01/01.2000 или «фдлврф»
 * @property {boolean} [isDigit] Признак того, что поле имеет тип «Число»
 * @property {boolean} [min] Допустимое минимальное числовое значение
 * @property {boolean} [max] Допустимое максимальное числовое значение
 * @property {boolean} [isEmail] Значение поля – адрес электронной почты
 * @since 5.0.0.4000
 *
 * @example
 * form.addCustomField("TO_ARCHIVE_DATE", toArchiveDateHtml, { "isRequired": true, "isDate": true });
 */

/**
 * Ссылка на объект
 * @typedef {Object} WebAccess.components.forms.FormBuilder.objectLink
 * @property {integer} id ИД объекта
 * @property {OBJECT_TYPE} type Тип объекта
 * @property {boolean} [referenceCode] Код справочника
 * @since 5.0.0.7100
*/

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

(function (global) {
  var FormBuilder = BaseObject.extend([WA.mixins.pluginMixin], {
    className: "FormBuilder",
    id: "",
    items: {},
    invalidFields: [],
    displayErrors: "tip",
    heigth: 100,
    _html: '',
    _orientaion: ORIENTATION.HORIZONTAL,
    _request: [],
    _action: "#",
    _method: FORM_METHOD.POST,
    _enctype: ENCTYPE.MULTIPART,
    _constructors: [],
    isHtmlFormEnabled: false,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    init: function (id) {
      if (!id) WA.raise("ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED", "id");
      this._super(id);
      this.id = id;

      //Это обязательно, не понятно почему, но оно не обнуляется само
      this.items = {};
      this.invalidFields = [];
      this._request = [];
      this._constructors = [];
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Изменить ориентацию содержимого формы.
    * Поддерживается вертикальная и горизонтальная ориентация.
    * Метод используется до вызова одной из функций добавления поля, например addText или addReferenceSelect,
    * сразу после вызова конструктора либо после вызова метода render.
    *
    * @function  WebAccess.components.forms.FormBuilder#setOrientation
    * @param {string} orientation Ориентация HTML-разметки. Возможные значения: "vertical" – поля располагаются под названием поля; "horizontal" – поле и его название располагаются в одной строке. Значение по умолчанию - "horizontal"
    * @return  {WebAccess.components.forms.FormBuilder} Oбъект класса FormBuilder.
    */
    setOrientation: function (orientation) {
      var me = this;
      if (!isNaN(orientation)) {
        if (orientation === 0) me._orientaion = 'horizontal';
        else me._orientaion = 'vertical';
      } else {
        this._orientaion = orientation;
      }

      var jForm = $("#" + this.id);
      if (jForm.length > 0) {
        jForm.find(".field_container").removeClass(me._orientaion).addClass(me._orientaion);
        jForm.find(".rs_SelItems_cont").removeAttr("style"); //хак для RefSel
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Получить значение поля.
    *
    * @function WebAccess.components.forms.FormBuilder#getValue
    * @param {string} name Строка локализации равная идентификатору этого поля
    * @param {boolean} [opt_byId] Признак, отключено ли внутреннее преобразование идентификатора. Если отключено, указанный идентификатор используется в неизменном виде
    * @return {string} Значение поля.
    */
    getValue: function (name, opt_byId) {
      if (!$("#" + this.id).length) WA.raise('ERR_UNABLE_TO_GET_THE_VALUE_FORM_IS_MISSING');

      var byId = byId || false;
      name = name.toLowerCase();
      var type = "";
      var value = "";
      var jField = $("#" + name);

      if (name in this.items) type = this.items[name].type;
      else type = "undefinied";

      switch (type) {
        case "text":
          jField = $("#" + name + "_label");
          value = jField.html();
          break;
        case "textFrame":
          value = jField.html();
          break;
        case "radio":
          value = jField.find('input[name="' + name + '"]:checked').val();
          break;
        case "input":
        case "date":
          value = jField.val();
          break;
        case "select":
          value = jField.val();
          break;
        case "referenceSelect":
        case "multiSelect":
          value = $("#hSelID_" + name).val();
          break;
        case "custom":
          if (!byId) value = $("#hSelID_" + name).val();
          else value = jField.val();
          break;
        case "pick":
          var pickInstance = $("#" + name + "inp").data('DropDownListInstance');
          value = pickInstance.getValue();
          if (value == "-1") value = "";
          break;
        case "objectList":
          return ListRequisite(name).GetLinks();
          break;
        case "undefinied":
          value = "";
          break;
        case "checkbox":
          value = jField.is(':checked');
          break;
        default:
          value = jField.val();
          break;
      }
      return value;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Устанавливает значение указанного поля.
    * Метод можно использовать, только когда поле уже отображаетсяна странице.
    * Например, если форма используется в модальном окне, то метод необходимо использовать только после события open модального окна:
    * dialog.bind('open', function() {
    *  form.setValue(.....)
    *  ...
    * })
    *
    * @function WebAccess.components.forms.FormBuilder#setValue
    * @param {string} name Строка локализации равная идентификатору этого поля
    * @param {string} value Значение поля
    * @param {string} displayValue Отображаемое значение поля
    * @param {boolean} [opt_byId] Отключить внутренние преобразования идентификатора, и использовать указанный.
    * @return  {WebAccess.components.forms.FormBuilder} Объект типа FormBuilder.
    */
    setValue: function (name, value, displayValue, opt_byId) {
      var byId = byId || false;
      name = name.toLowerCase();
      var type = "";
      var jField = $("#" + name);

      if (name in this.items) type = this.items[name].type;
      else type = "undefinied";

      switch (type) {
        case 'radio':
          var jRadios = jField.find('input[name="' + name + '"]');
          jRadios.filter('[value="' + value + '"]').prop('checked', true);
          break;
        case "referenceSelect":
        case "multiSelect":
          WA.CMP.wrappers.form.requisites.BaseObjectSelectRequisite.setControlValue(jField, value, displayValue);
          break;
        case "pick":
          setTimeout(function () {
            var pickInstance = $("#" + name + "inp").data('DropDownListInstance');
            pickInstance.setValue(value, displayValue);
          }, 10);
          break;
        case "undefinied":
          break;
        case "text":
          jField = $("#" + name + "_label");
          jField.html(L(value));
          break;
        case "textFrame":
          jField.html(value);
          break;
        case "objectList":
          var list = ListRequisite(name);
          var links = [];

          for (var i in value) {
            links.push({
              'ID': value[i].id,
              'Kind': objectTypeToString(value[i].type),
              'referenceName': value[i].CompCode
            });
          }
          list.Values = links;
          list.UpdateList();
          break;
        case 'date':
          if (typeof value === "object") {
            value = formatDate(value);
          }
          jField.val(value);
          break;
        case 'checkbox':
          if (!!value) jField.attr('checked', 'checked');
          else jField.removeAttr('checked');
          break;
        default:
          jField.val(value);
          break;
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Выкидывает исключение при попытке добавить одно и то-же поле
    * @private
    * @function WebAccess.components.forms.FormBuilder#_preventDoubles
    */
    _preventDoubles: function (id) {
      if (this.items[id]) WA.raise("ERR_FIELD_WITH_THE_SAME_NAME_ALREADY_EXIST");
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получить отображаемое значение поля.
     *
     * @param {string} name Имя поля
     * @function WebAccess.components.forms.FormBuilder#getDisplayValue
     * @return {string} Отображаемое значение поля.
     */
    getDisplayValue: function (name) {
      var type = "";
      name = name.toLowerCase();
      var value = "";
      var jField = $("#" + name);

      if (name in this.items) type = this.items[name].type;
      else type = "undefinied";
      switch (type) {
        case "text":
          jField = $("#" + name + "_label");
          jField.html(L(value));
          break;
        case "textFrame":
          value = jField.html();
          break;
        case "pick":
          var pickInstance = $("#" + name + "inp").data('DropDownListInstance');
          value = pickInstance.getDisplayValue();
          break;
        case "multiSelect":
        case "referenceSelect":
          var values = [];
          $('#' + name + '_container').find('.rs_SelItems').children("span").each(function () {
            values.push($(this).attr("data-text"));
          });
          value = values.join(';');
          break;
        case "undefinied":
          value = "";
          break;
        case "objectList":
          WA.raise('ERR_UNSUPPORTED_METHOD');
          break;
        default:
          value = jField.val();
          break;
      }
      return value;
    },

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получить высоту формы.
     * Устаревший метод, оставлен для совместимости с предыдущими версиями. Не рекомендуется его использовать.
     *
     * @function WebAccess.components.forms.FormBuilder#getHeight
     * @return {integer} Высота формы.
     * @since 5.0.0.4000
     * @deprecated
     */
    getHeight: function () {
      return this.heigth;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Получить высоту формы.
    *
    * @deprecated
    * @alias WebAccess.components.forms.FormBuilder#getHeight
    * @function WebAccess.components.forms.FormBuilder#getHeigth
    * @ignore
    */
    getHeigth: function () { return this.getHeight.apply(this, arguments); },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Удаление поля с формы
     * @function WebAccess.components.forms.FormBuilder#_removeField
     * @private
     * @param  {string} name идентификатор поля
     * @return {WebAccess.components.forms.FormBuilder}
     */
    _removeField: function (id) {
      if (!id) WA.raise("ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED", "name");
      this._preventDoubles(id);
      $("#" + name.toLowerCase() + "_container").remove();
      this.items[id] = { 'id': id }; //В этой строке заключается порядок, убрать её, значит нарушить его.
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавить текст на форму.
    *
    * @function WebAccess.components.forms.FormBuilder#addText
    * @param {string} name Строка локализации равная идентификатору этого поля
    * @return {WebAccess.components.forms.FormBuilder} Oбъект класса FormBuilder.
    */
    addText: function (name) {
      var me = this;
      var id = name.toLowerCase();
      me._removeField(id);

      var constructor = {
        template: 'formBuilder/text.compile.html',
        params: {
          'id': id,
          'text': L(name)
        },

        afterRender: function (html) {
          me._addItem(name, id, false, 'text', html, null);
        }
      };

      me._constructors.push(constructor);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Для вставки звездочки в обязательные поля
    * @private
    */
    _asterisk: function (label, rules) {
      if (rules && rules['isRequired'] && label !== '') {
        return '*';
      }
      return '';
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавить поле типа «Текст».
    *
    * @function WebAccess.components.forms.FormBuilder#addInput
    * @param {string} name Строка локализации равная идентификатору этого поля
    * @param {number} [opt_maxlength] Допустимое количество символов в поле
    * @param {WebAccess.components.forms.FormBuilder.validatorRules} [opt_validateRules] Правила корректности заполнения формы
    * @param {string} [opt_accept] Строка для атрибута "accept", например ".xls,.xlsx"
    * @return {WebAccess.components.forms.FormBuilder} Oбъект класса FormBuilder.
    */
    addInput: function (name, opt_maxlength, opt_validateRules, opt_type, opt_defaultValue, opt_accept) {
      var me = this;
      var id = name.toLowerCase();
      me._removeField(id);
      opt_type = opt_type || 'input';
      opt_maxlength = opt_maxlength || '';
      opt_defaultValue = opt_defaultValue || '';
      opt_accept = opt_accept || '';

      var label = L(name);
      var constructor = {
        template: 'formBuilder/input.compile.html',
        params: {
          'id': id,
          'orientation': me._orientaion,
          'asterisk': me._asterisk(label, opt_validateRules),
          'label': (label === '' ? '' : label + ':'),
          'type': (opt_type == 'input') ? 'text' : opt_type,
          'max': opt_maxlength,
          'value': opt_defaultValue,
          'accept': opt_accept
        },
        afterRender: function (html) {
          me._addItem(name, id, false, opt_type, html, opt_validateRules);
        }
      };

      me._constructors.push(constructor);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавить поле типа «File».
    *
    * @function WebAccess.components.forms.FormBuilder#addFileField
    * @param {string} name Строка локализации равная идентификатору поля
    * @param {WebAccess.components.forms.FormBuilder.validatorRules} [opt_validateRules] Правила корректности заполнения формы
    * @param {string} [opt_accept] Строка для атрибута "accept", например ".xls,.xlsx", а лучше вместе с MIME-type:
    * ".xls,.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
    * (см. https://w3c.github.io/html/sec-forms.html#element-attrdef-input-accept)
    * @return {WebAccess.components.forms.FormBuilder} Oбъект класса FormBuilder.
    */
    addFileField: function (name, opt_validateRules, opt_accept) {
      return this.addInput(name, null, opt_validateRules, 'file', '', opt_accept);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавить скрытое поле.
    *
    * @function WebAccess.components.forms.FormBuilder#addHiddenField
    * @param {string} name Строка локализации равная идентификатору поля
    * @param {string} value Значение поля
    * @return {WebAccess.components.forms.FormBuilder} Oбъект класса FormBuilder.
    */
    addHiddenField: function (name, value) {
      var me = this;
      var id = name.toLowerCase();
      me._removeField(id);

      var constructor = {
        template: 'formBuilder/hidden.compile.html',
        params: {
          'id': id,
          'value': value
        },
        afterRender: function (html) {
          me._addItem(name, id, false, "datehidden", html, null);
        }
      };

      me._constructors.push(constructor);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавить поле для выбора даты.
    *
    * @method WebAccess.components.forms.FormBuilder#addDate
    * @param {string} name Строка локализации равная идентификатору поля
    * @param {WebAccess.components.forms.FormBuilder.validatorRules}  [opt_validateRules] Правила корректности заполнения формы
    * @return {WebAccess.components.forms.FormBuilder} Oбъект класса FormBuilder.
    */
    addDate: function (name, opt_validateRules) {
      var me = this;
      var id = name.toLowerCase();
      me._removeField(id);

      var constructor = {
        template: 'formBuilder/date.compile.html',
        params: {
          'id': id
        },
        afterRender: function (html) {
          html = me._wrapControl(id, html, opt_validateRules);
          me._addItem(name, id, false, "date", html, opt_validateRules);
        }
      };

      me._constructors.push(constructor);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавить многострочное поле.
    *
    * @function WebAccess.components.forms.FormBuilder#addTextarea
    * @param {string} name Строка локализации равная идентификатору этого поля
    * @param {string} opt_defaultvalue Значение по умолчанию
    * @param {WebAccess.components.forms.FormBuilder.validatorRules}  [opt_validateRules] Правила корректности заполнения формы
    * @return {WebAccess.components.forms.FormBuilder} Oбъект класса FormBuilder.
    */
    addTextArea: function (name, opt_defaultvalue, opt_validateRules) {
      var me = this;
      var id = name.toLowerCase();
      me._removeField(id);

      var label = L(name);
      var constructor = {
        template: 'formBuilder/textArea.compile.html',
        params: {
          'id': id,
          'orientation': me._orientaion,
          'asterisk': me._asterisk(label, opt_validateRules),
          'label': (label === '' ? '' : label + ':'),
          'value': opt_defaultvalue
        },
        afterRender: function (html) {
          me._addItem(name, id, false, "textArea", html, opt_validateRules);
        }
      };

      me._constructors.push(constructor);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Добавить многострочное поле фиксированной высоты.
    *
    * @function WebAccess.components.forms.FormBuilder#addTextFrame
    * @param {string} name Строка локализации равная идентификатору поля
    * @param {string} defaultvalue Значение по умолчанию
    * @param {integer} [opt_maxHeigth] Высота, в рамках которой ограничивается поле
    * @param {WebAccess.components.forms.FormBuilder.validatorRules}  [opt_validateRules] Правила коррктности заполнения формы
    * @return {WebAccess.components.forms.FormBuilder} Объект класса FormBuilder.
    * @since 5.1.0.1523
    */
    addTextFrame: function (name, opt_defaultvalue, opt_maxHeigth, opt_validateRules) {
      var me = this;
      var id = name.toLowerCase();
      me._removeField(id);

      opt_maxHeigth = opt_maxHeigth || '150';
      opt_maxHeigth = opt_maxHeigth + 'px';

      var label = L(name);
      var constructor = {
        template: 'formBuilder/textFrame.compile.html',
        params: {
          'id': id,
          'maxHeigth': opt_maxHeigth,
          'orientation': me._orientaion,
          'asterisk': me._asterisk(label, opt_validateRules),
          'label': (label === '' ? '' : label + ':'),
          'value': opt_defaultvalue
        },
        afterRender: function (html) {
          me._addItem(name, id, false, "textFrame", html, opt_validateRules);
        }
      };

      me._constructors.push(constructor);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Добавить многострочное поле.
    * @deprecated
    * @alias WebAccess.components.forms.FormBuilder#addTextArea
    * @function WebAccess.components.forms.FormBuilder#addTextarea
    * @ignore
    */
    addTextarea: function () {
      return this.addTextArea.apply(this, arguments);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавить поле выбора из списка.
    *
    * @function WebAccess.components.forms.FormBuilder#addSelect
    * @param {string} name Строка локализации равная идентификатору этого поля
    * @param {dictionary} options Список элементов выбора
    * @param {WebAccess.components.forms.FormBuilder.validatorRules}  [opt_validateRules] Правила корректности заполнения формы
    * @return {WebAccess.components.forms.FormBuilder} Oбъект класса FormBuilder.
    */
    addSelect: function (name, options, opt_validateRules) {
      var me = this;
      var id = name.toLowerCase();
      me._removeField(id);


      var mustache_options = [];
      for (var prop in options) {
        if (options.hasOwnProperty(prop)) {
          mustache_options.push({
            'key': prop,
            'value': L(options[prop])
          });
        }
      }

      var label = L(name);
      var constructor = {
        template: 'formBuilder/select.compile.html',
        params: {
          'id': id,
          'orientation': me._orientaion,
          'asterisk': me._asterisk(label, opt_validateRules),
          'label': (label === '' ? '' : label + ':'),
          'options': mustache_options
        },
        afterRender: function (html) {
          me._addItem(name, id, false, "select", html, opt_validateRules);
        }
      };

      me._constructors.push(constructor);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавить группу переключателей.
    *
    * @function WebAccess.components.forms.FormBuilder#addRadioButtons
    * @param {string} name Строка локализации, равная идентификатору этого поля
    * @param {dictionary} options Список элементов выбора
    * @param {WebAccess.components.forms.FormBuilder.validatorRules}  [opt_validateRules] Правила корректности заполнения формы
    * @return {WebAccess.components.forms.FormBuilder} Oбъект класса FormBuilder.
    * @since 5.1.0.1505
    */
    addRadioButtons: function (name, options, opt_validateRules, opt_defaultvalue) {
      var me = this;
      var id = name.toLowerCase();
      me._removeField(id);
      opt_defaultvalue = opt_defaultvalue || null;

      var mustache_options = [];
      for (var prop in options) {
        if (options.hasOwnProperty(prop)) {
          mustache_options.push({
            'key': prop,
            'value': L(options[prop]),
            'checked': opt_defaultvalue == prop ? 'checked="checked"' : ''
          });
        }
      }

      var label = L(name);
      var constructor = {
        template: 'formBuilder/radio.compile.html',
        params: {
          'id': id,
          'orientation': me._orientaion,
          'asterisk': me._asterisk(label, opt_validateRules),
          'label': (label === '' ? '' : label + ':'),
          'options': mustache_options
        },
        afterRender: function (html) {
          me._addItem(name, id, false, "radio", html, opt_validateRules);
        }
      };

      me._constructors.push(constructor);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
     * Добавить поле типа «Справочник».
     *
     * @function WebAccess.components.forms.FormBuilder#addReferenceSelect
     * @param  {string} name                Строка локализации равная идентификатору этого поля
     * @param  {string} referenceCode       Код справочника
     * @param  {string} [opt_toolTip]       Текст всплывающей подсказки для кнопки выбора из справочника
     * @param  {string} [opt_searchReqName] Отображаемый реквизит. По умолчанию реквизит «Наименование»
     * @param  {string} [opt_filter]        Выражение фильтрации. Для выбора будут доступны только отфильтрованные записи указанного справочника
     * @param  {WebAccess.components.forms.FormBuilder.validatorRules} [opt_validateRules] Правила корректности заполнения формы
     * @return  {WebAccess.components.forms.FormBuilder} Oбъект класса FormBuilder.
     */
    addReferenceSelect: function (name, referenceCode, opt_toolTip, opt_searchReqName, opt_filter, opt_validateRules) {
      var me = this;
      var id = name.toLowerCase();
      this._removeField(id);

      var other = {
        'referenceCode': referenceCode,
        'toolTip': opt_toolTip,
        'searchReqName': opt_searchReqName,
        'filter': opt_filter
      };

      me._addItem(name, id, true, "referenceSelect", '', opt_validateRules, other);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Добавить поле типа «Список объектов».
     *
     * @function WebAccess.components.forms.FormBuilder#addObjectList
     * @param  {string} name                Строка локализации равная идентификатору этого поля.
     * @param  {string} type                Возможные значения: EDOCUMENT, JOB, FOLDER, TASK, REFERENCE_RECORD, ANY
     * @param  {WebAccess.components.forms.FormBuilder.objectLink} opt_liks  Ссылки объектов по умолчанию. Подробнее см. WebAccess.components.forms.FormBuilder.objectLink
     * @param  {boolean} opt_isList         Значение True, если можно вставить несколько объектов в поле, иначе False
     * @param  {string} referenceCode       Код справочника.
     * @param  {WebAccess.components.forms.FormBuilder.validatorRules} [opt_validateRules] Правила корректности заполнения формы
     * @return  {WebAccess.components.forms.FormBuilder} Oбъект класса FormBuilder.
     * @since 5.0.0.7100
     *
     * @example
     * var form = new WA.CMP.forms.FormBuilder("1")
     *     form.addObjectList("YEsdscSd", OBJECT_TYPE.REFERENCE_RECORD,[{"id": "103619", "type": OBJECT_TYPE.REFERENCE_RECORD, "referenceCode": "ПРС"}], true,'ПРС')
     *
     * var dialog = new WA.CMP.dialogs.BaseDialog("as")
     *      dialog.setHtml(form.render())
     *      dialog.width = 700
     *      dialog.show()
     */
    addObjectList: function (name, type, opt_links, opt_isList, opt_referenceCode, opt_validateRules) {
      var me = this;

      var id = name.toLowerCase();
      this._removeField(id);

      var other = {
        "object_type": type,
        "values": opt_links,
        "isList": opt_isList,
        "referenceCode": opt_referenceCode
      };

      me._addItem(name, id, true, "objectList", '', opt_validateRules, other);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавить поле множественного выбора из справочника.
    *
    * @function WebAccess.components.forms.FormBuilder#addMultiSelect
    * @param  {string} name                Строка локализации равная идентификатору этого поля
    * @param  {string} referenceNames      Коды справочников, разделенные ";"
    * @param  {string} [opt_toolTip]       Текст всплывающей подсказки
    * @param  {string} [opt_searchReqName] Отображаемый реквизит
    * @param  {string} [opt_filter]        Выражение фильрации. В поле будут доступны только отфильтрованные записи выбранного справочника
    * @param  {boolean} [opt_isMultiSelect] Признак множественного выбора
    * @param  {WebAccess.components.forms.FormBuilder.validatorRules} [opt_validateRules] Правила корректности заполнения формы
    * @return  {WebAccess.components.forms.FormBuilder} Oбъект класса FormBuilder.
    * @since 5.0.0.4106
    */
    addMultiSelect: function (name, referenceNames, opt_toolTip, opt_searchReqName, opt_filter, opt_isMultiSelect, opt_validateRules) {
      var me = this;

      var id = name.toLowerCase();
      this._removeField(id);

      var other = {
        'referenceNames': referenceNames,
        'toolTip': opt_toolTip,
        'searchReqName': opt_searchReqName,
        'filter': opt_filter,
        'isMultiSelect': opt_isMultiSelect
      };

      me._addItem(name, id, true, "multiSelect", '', opt_validateRules, other);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Добавить поле типа «Признак».
     *
     * @function WebAccess.components.forms.FormBuilder#addPick
     * @param  {string} name                Строка локализации равная идентификатору этого поля
     * @param  {dict} values                Ассоциативный массив, содержащий пары: ИД пункта выпадающего списка – отображаемое значение пункта
     * @param  {dict} [opt_displayValues]     Отображаемые значения для выпадающего списка
     * @param  {array} [opt_disabledValues]   Пункты недоступные для выбора
     * @param  {boolean} [opt_editable]       Если значение true, то поле ввода становится доступным для изменения. В случае, если значение было введено вручную, метод getValue вернет пустую строку. Такое значение необходимо получать методом getDisplayValue
     * @param  {WebAccess.components.forms.FormBuilder.validatorRules} [opt_validateRules] Правила корректности заполнения формы
     * @return  {WebAccess.components.forms.FormBuilder} Текущий конструктор форм.
     */
    addPick: function (name, values, opt_displayValues, opt_disabledValues, opt_editable, opt_validateRules) {
      var me = this;

      var id = name.toLowerCase();
      this._removeField(id);
      var other = {
        'values': values,
        'displayValues': opt_disabledValues,
        'disabledValues': opt_disabledValues,
        'editable': opt_editable
      };

      me._addItem(name, id, true, "pick", '', opt_validateRules, other);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавить поле информацию о поле во внутренний объект
    * @since 5.0.0.7100
    * @private
    */
    _addItem: function (name, id, fromServerSide, type, html, validateRules, other) {
      this.items[id] = {
        'id': id,
        'name': name,
        'fromServerSide': fromServerSide,
        "type": type,
        'validateRules': validateRules,
        'data': html
      };

      if (other) {
        $.extend(this.items[id], other);
      }
    },

    /**
    * Добавить поле с произвольным содержимым.
    *
    * @function WebAccess.components.forms.FormBuilder#addCustomField
    * @param {string} name Строка локализации равная идентификатору этого поля
    * @param {string} html HTML-разметка. Должна содержать указанный параметр name
    * @param {WebAccess.components.forms.FormBuilder.validatorRules}  [opt_validateRules] Правила корректности заполнения формы
    * @return  {WebAccess.components.forms.FormBuilder} Oбъект класса FormBuilder.
    */
    addCustomField: function (name, html, opt_validateRules, opt_type) {
      var me = this;
      var id = name.toLowerCase();
      me._removeField(id);
      var type = (!!opt_type) ? opt_type : "custom";
      var item = me._wrapControl(id, html, opt_validateRules);

      me._addItem(name, id, false, type, item, opt_validateRules);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Обернуть контрол в контейнер с нужными отступами
    * Следуюя общему принципу эта функция тоже должна быть асинхронной
    * и использовать шаблоны, но в силу сложности дальнейших доработок и
    * ограниченности времени оставется в текущем виде
    * @todo перенести на шаблоны
    * @private
    * @since 5.0.0.7001
    */
    _wrapControl: function (id, control_html, opt_validateRules) {
      var label = L(id.toUpperCase());
      var html = "<div id='" + id + "_container' class='field_container " + this._orientaion + "'>";
      html += format("<label id='{id}_label' for='{id}'>{asterisk}{label}<span id='{id}_mt_error' class='mt_error'></span></label>", {
        'id': id,
        'label': (label === '' ? '' : label + ':'),
        'asterisk': this._asterisk(label, opt_validateRules)
      });

      html += '<div class="control_container">' + control_html + '</div>';
      html += "</div>";
      return html;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавить переключатель.
    *
    * @function WebAccess.components.forms.FormBuilder#addCheckbox
    * @param {string} name Строка локализации равная идентификатору этого поля
    * @param {bool} opt_isChecked Проверяет, установлен переключатель или нет
    * @param {WebAccess.components.forms.FormBuilder.validatorRules}  [opt_validateRules] Правила корректности заполнения формы
    * @return  {WebAccess.components.forms.FormBuilder} Oбъект класса FormBuilder.
    * @since 5.0.0.4301
    */
    addCheckbox: function (name, opt_isChecked, opt_validateRules) {
      var me = this;
      var id = name.toLowerCase();
      this._removeField(id);

      var label = L(name);
      var constructor = {
        'template': 'formBuilder/checkBox.compile.html',
        'params': {
          'id': id,
          'label': label,
          'asterisk': me._asterisk(label, opt_validateRules),
          'isChecked': opt_isChecked === true ? 'checked="checked"' : '',
          'orientation': this._orientaion
        },
        'afterRender': function (html) {
          me._addItem(name, id, false, "checkbox", html, opt_validateRules);
        }
      };

      me._constructors.push(constructor);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Попытка получить значение контрола всеми возможными способами.
     * @private
     * @function WebAccess.components.forms.FormBuilder#_tryGetValue
     */
    _tryGetValue: function (item) {
      var value = this.getValue(item["id"]) || this.getDisplayValue(item["id"]);
      if (typeof value == 'undefined') value = this.getValue(item["id"], true);
      if (typeof value == 'undefined') value = '';
      if (item.type === 'objectList') {
        if (value.links && value.links.length > 0)
          return 'undefined';
        else
          return '';
      }
      return value;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавить правила корректности ввода данных.
    *
    * @function WebAccess.components.forms.FormBuilder#addValidationRule
    * @param {string} name Название правила
    * @param {function} handler Функция проверки правила
    * @param {string} opt_error_message Сообщение об ошибке, возникающей при невыполнении правила
    *
    * @example
    * // К правилам корректности ввода данных добавляется новое «MoreThanTen».
    * // Правило означает, что форма заполнена правильно, если значение поля больше 10.
    * var form = new WA.CMP.forms.FormBuilder('buldy');
    * form.addValidationRule('moreThanTen', function(value, display) {
    *    console.log(arguments);
    *    if (value < 10) return false;
    *    return true;
    * }, L('ERROR'));
    *
    * var dialog = new WA.CMP.dialogs.BaseDialog();
    *
    * //Применяем правило к полю «YES».
    * form.addInput("YES", 100, {'isRequired': true, 'moreThanTen': true});
    * dialog.setHtml(form.render());
    * dialog.show();
    * dialog.ok = function() {
    * if (form.isValid() !== true) return false;
    *
    * }
    */
    addValidationRule: function (name, handler, opt_error_message) {
      this._validators[name] = {};
      this._validators[name].handler = handler;
      this._validators[name].error = opt_error_message;
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Проверить корректность значений.
     * @function WebAccess.components.forms.FormBuilder#isValid
     * @return {boolean} True, если значения полей формы корректны, иначе False.
     */
    isValid: function () {
      var me = this;
      this.invalidFields = [];

      $.each(me.items, function (key, item) {
        if (item["validateRules"]) {
          var rules = item["validateRules"];

          // Забываем все предыдущие ошибки полей
          me._markAsValid(item);
          item.error = "";
          $('#' + item["id"] + '_mt_error').html("");

          // Проверка на обязательность, она особая и запускается отдельно
          if (rules.isRequired) {
            if (me._validators['isRequired']['handler'](me._tryGetValue(item)) === false) {
              item.error = me._validators['isRequired']['error'] || L('ERROR');
              me._markAsInvalid(item);
            }
          }

          /**
          * Остальные правила
          */
          for (var ruleName in me._validators) {
            if (rules[ruleName] && !item.error && me._tryGetValue(item) !== '') {
              if (me._validators[ruleName]['handler'](me._tryGetValue(item), me.getDisplayValue(item.id), rules[ruleName]) === false) {
                item.error = me._validators[ruleName]['error'] || L('ERROR');
                me._markAsInvalid(item);
              }
            }
          }
        }
      });
      var prevColor;
      //Изменение внешнего вида невалидных полей
      $.each(this.invalidFields, function (index, item) {
        var jBorder = me._getFieldBorder(item).addClass("Req_Error");
        if (!prevColor) prevColor = jBorder.css('backgroundColor');
        var highlight = "#F6DADA";

        jBorder.animate({ backgroundColor: highlight }, 300, function () {
          jBorder.animate({ backgroundColor: prevColor }, 300);
        });

        if (me.displayErrors == "inline") {
          var errorsHtml = format("<span class='label_separator'>&nbsp;</span>({0})", item.error);
          $(format("#{0}_mt_error", item["id"])).html(errorsHtml);
        }

        if (me.displayErrors == "tip") {
          var el = jBorder;
          if (item.type == 'referenceSelect') el = el.siblings('.rs_SelItems_cont');
          el.qtip({
            style: { classes: "ui-tooltip-light ui-tooltip-shadow ui-tooltip-rounded" },
            content: { text: item.error },
            events: {
              render: function (event, api) {
                setTimeout(function () { el.qtip("destroy"); }, 2000);
              }
            }
          });
        }

      });

      if (this.invalidFields.length > 0) return false;
      return true;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Чтобы отметить поле невалидным визуально, нужно знать как с ним работать
     * тут перечилены селекторы, которые отвечают за границы элементов ввода
     * @function WebAccess.components.forms.FormBuilder#_getFieldBorder
     * @private
     * @todo: некрасиво, отрефакторить
     * @param  {object} item
     */
    _getFieldBorder: function (item) {
      var element = null;
      var selector = $("#" + item["id"]);
      switch (item["type"]) {
        case "custom":
          element = selector.parents("span").find(".fakeInput");
          break;
        case "referenceSelect":
        case "multiSelect":
          element = selector.parents("span").find(".fakeInput");
          break;
        case "objectList":
          element = selector.find(".ListRequisiteBorder");
          break;
        case "pick":
          element = $("#" + item["id"] + "inp");
          break;
        default:
          element = selector;
          break;
      }
      return element;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отметка элемента невалидным, то что его представление
     * будет крассным обрабатывается уже не здесь
     * @private
     * @function WebAccess.components.forms.FormBuilder#_markAsInvalid
     * @param  {object} item
     */
    _markAsInvalid: function (item) {
      var id = item["id"];
      this.invalidFields.push(item);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отметка элемента валидным
     * @function WebAccess.components.forms.FormBuilder#_markAsValid
     * @private
     * @param  {object} item
     */
    _markAsValid: function (item) {
      var id = item["id"];
      this._getFieldBorder(item).removeClass("Req_Error");
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Заполенение данных для отображения.
    * @private
    * @since 5.0.0.7100
    */
    _fillItem: function (id, result, opt_validateRules) {
      var me = this;
      var html = result.html + '<script>' + result.initJs + '</script>';
      me.items[id].data = me._wrapControl(id, html, opt_validateRules);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /*
    * Установить адрес для отправки формы.
    *
    * @function WebAccess.components.forms.FormBuilder#setAction
    * @param {string} url Адрес для отправки формы
    * @return {WebAccess.components.forms.FormBuilder} Текущий конструктор форм.
    * @since 5.0.0.7100
    */
    setAction: function (url) {
      var me = this;
      me.isHtmlFormEnabled = true;
      me._action = url;
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /*
    * Метод для отправки формы.
    *
    * @function WebAccess.components.forms.FormBuilder#setMethod
    * @param {FORM_METHOD} form_method Метод для отправки формы
    * @return {WebAccess.components.forms.FormBuilder} Текущий конструктор форм.
    * @since 5.0.0.7100
    */
    setMethod: function (form_method) {
      var me = this;
      me.isHtmlFormEnabled = true;
      me._method = form_method;
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /*
    * Установить тип содержимого формы.
    *
    * @function WebAccess.components.forms.FormBuilder#setEnctype
    * @param {ENCTYPE} enctype Тип содержимого формы
    * @return {WebAccess.components.forms.FormBuilder} Текущий конструктор форм.
    * @since 5.0.0.7100
    */
    setEnctype: function (enctype) {
      var me = this;
      me.isHtmlFormEnabled = true;
      me._enctype = enctype;
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /*
    * Отправить форму.
    *
    * @function WebAccess.components.forms.FormBuilder#submit
    * @return {WebAccess.components.forms.FormBuilder} Текущий конструктор форм.
    * @since 5.0.0.7100
    */
    submit: function () {
      $("#" + this.id + " form").submit();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Гененерировать форму.
    *
    * @function WebAccess.components.forms.FormBuilder#render
    * @return {string} Сгенерированная HTML-разметка.
    */
    render: function () {
      var me = this;
      me._render(true);
      return me._html;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Генерировать форму с помощью асинхронного вызова.
    *
    * @function WebAccess.components.forms.FormBuilder#renderAsync
    * @return {Deferred} Специальный deferred-объект.
    * @since 5.0.0.7100
    */
    renderAsync: function () {
      return this._render(false);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * @private
    * @function WebAccess.components.forms.FormBuilder#_render
    * @return {Deferred} jquery deferred объект
    * @since 5.0.0.7100
    */
    _render: function (sync) {
      var me = this;
      var jMasterDeferred = $.Deferred();
      me.clean();

      var deferreds = [];
      for (var i = 0; i < me._constructors.length; i++) {
        var c = me._constructors[i];
        deferreds.push(WA.templates.render(c.template, c.params, false, sync).done(c.afterRender));
      }

      //Когда все поля готовы, делаем запрос
      $.when.apply(me, deferreds).then(function () {

        //TODO Шамов А.: Я думаю стоит переделать логику на на формирование запросов, засовывание в кэш, и рендеринг из кэша.
        // На мой взгляд это будет более понятно и не будет дублирования функции _fillItem.
        // Сейчас странно что _preRender только в этой части условия вызывается, а не в общей.

        me._preRender();
        var launchPostRender = function () {
          me._postRender(sync).done(function () {
            jMasterDeferred.resolve.apply(this, arguments);
          }).error(function () {
            jMasterDeferred.reject.apply(this, arguments);
          });
        };

        if (me._request.length) {
          var method = (sync) ? 'buildSync' : 'build';
          WA.SRV.requisite[method](me._request).done(function (result) {
            me._parseServiceResult(result);
            launchPostRender();
          });
        } else {
          launchPostRender();
        }
      });

      return jMasterDeferred;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Разбор ответа сервиса
    * @private
    * @since 5.0.0.7100
    */
    _parseServiceResult: function (result) {
      var me = this;
      for (var id in me._request) {
        var request = me._request[id];
        var name = request.id;
        if (typeof request == 'function') continue;
        WA.cache.setObject('field.' + getHash(JSON.stringify(request)), result[name]);
        me._fillItem(name, result[name], request.validateRules);
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Формирование запроса
    * @private
    * @since 5.0.0.7100
    */
    _preRender: function () {
      var me = this;
      me._request = [];

      /**
      * Если не можем взять реквизит из кеша по хешу,
      * то добавляем его в запрос
      */
      for (var i in me.items) {
        var request = this.items[i];
        if (request["fromServerSide"]) {
          var name = request.id;
          var cached = WA.cache.getObject('field.' + getHash(JSON.stringify(request)));
          if (!cached) {
            me._request.push(this.items[i]);
          } else {
            me._fillItem(name, cached, request.validateRules);
          }
        }
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Формирование разметки
    * @private
    * @since 5.0.0.7100
    */
    _postRender: function (sync) {
      var me = this;

      var content = '';
      for (var id in this.items) {
        content += this.items[id]["data"];
      }

      var t = WA.templates.render('formBuilder/formLayout.compile.html', {
        'id': me.id,
        'action': me._action,
        'method': me._method,
        'enctype': me._enctype,
        'orientation': me._orientaion,
        'isHorizontal': me._orientaion == 'horizontal',
        'content': content,
        'isHtmlFormEnabled': me.isHtmlFormEnabled
      }, false, sync).done(function (html) {
        me._html = html;
      });

      return t;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Очистить форму.
    *
    * @function WebAccess.components.forms.FormBuilder#clean
    * @return {WebAccess.components.forms.FormBuilder} Oбъект класса FormBuilder.
    */
    clean: function () {
      $("#" + this.id).remove();
      this._html = '';
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Делает неактивным контрол формы.
    * @private
    * @function WebAccess.components.forms.FormBuilder#disable
    * @param {string} name Строка локализации равная идентификатору этого поля
    * @return  {WebAccess.components.forms.FormBuilder} Объект типа FormBuilder.
    * @since 5.3.0.1002
    */
    disable: function (name) {
      name = name.toLowerCase();
      var jField = $("#" + name);

      // TODO доделать для остальных.

      var type = "";
      if (name in this.items) type = this.items[name].type;
      else type = "undefinied";

      switch (type) {
        case 'radio':
          //var jRadios = jField.find('input[name="' + name + '"]');
          //jRadios.filter('[value="' + value + '"]').prop('checked', true);
          break;
        case "referenceSelect":
        case "multiSelect":
          //WA.CMP.wrappers.form.requisites.BaseObjectSelectRequisite.setControlValue(jField, value, displayValue);
          break;
        case "pick":
          //TODO закэшировать в классе.
          var pickWrapper = new WA.CMP.wrappers.form.requisites.Pick(name, name);
          pickWrapper.disable();
          break;
        case "undefinied":
          break;
        case "text":
          //jField = $("#" + name + "_label");
          //jField.html(L(value));
          break;
        case "textFrame":
          //jField.html(value);
          break;
        case "objectList":
          //var list = ListRequisite(name);
          //var links = [];

          //for (var i in value) {
          //  links.push({
          //    'ID': value[i].id,
          //    'Kind': objectTypeToString(value[i].type),
          //    'referenceName': value[i].CompCode
          //  });
          //}
          //list.Values = links;
          //list.UpdateList();
          break;
        case 'date':
          //jField.val(value);
          break;
        case 'checkbox':
          //if (!!value) jField.attr('checked', 'checked');
          //else jField.removeAttr('checked');
          break;
        default:
          //jField.val(value);
          break;
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Сериализация формы
    *
    * @since 5.0.0.7300
    * @ignore
    * @function WebAccess.components.forms.FormBuilder#serialize
    * @return  {WebAccess.components.forms.FormBuilder}
    */
    serialize: function (type) {

      switch (type) {
        case SERIALIZATION.FULL:
          return this._fullSerialization();
          break;
        case SERIALIZATION.LITE:
        default:
          return this._defaultSerialization();
          break;
      }


    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    _defaultSerialization: function () {
      var form = {
        source: 'FormBuilder',
        requisites: {}
      };

      var name;
      for (name in this.items) {
        if ($.isPlainObject(this.items[name])) {
          try {
            if (this.items[name].type == 'text') continue;
            form.requisites[name] = [this.getValue(name), this.getDisplayValue(name)];
          } catch (e) { }
        }
      }
      return form;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    //TODO: Научить работать с FormDialog
    _fullSerialization: function () {
      var me = this;
      var result = {
        ID: me.id,
        Actions: null,
        Caption: null,
        FType: 0,
        FormJS: null
      };
      var formData = {
        source: 'FormBuilder',
        obj: null,
        isNew: false,
        isreadonly: false,
        tab: null,
        view: null
      };

      result.FormData = $.toJSON(formdata);

      //TODO: дополнить
      var reqTypes = {
        'input': 'string',
        'referenceSelect': 'reference',
        'multiSelect': 'reference',
        'date': 'date',
        'pick': 'pick'
      };

      var keys = _(this.items).pluck('name');
      var controls = _(this.items).pluck('id');
      var values = _(this.items).map(function (req) {
        return {
          value: me.getValue(req.name),
          displayValue: me.getDisplayValue(req.name),
          isVisible: true,
          isRequired: req.validateRules && req.validateRules.isRequired,
          type: reqTypes[req.type],
          controls: [req.id]
        }
      });

      data.req = _.object(keys, values);
      data.reqUD_inv = _(controls, keys);
      return result;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Десериализация формы
    * @since 5.0.0.7300
    * @ignore
    * @function WebAccess.components.forms.FormBuilder#deserialize
    * @return  {WebAccess.components.forms.FormBuilder}
    */
    deserialize: function (form) {
      for (name in form.requisites) {
        if ($.isPlainObject(this.items[name])) {
          try {
            if (this.items[name].type == 'text') continue;
            if (!form.requisites[name].value) continue;
            this.setValue(name, form.requisites[name][0]);
            this.setDisplayValue(name.requisites, form[name][1]);
          } catch (e) { }
        }
      }
      return this;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  });

  global.FormBuilder = FormBuilder;
})(window.WebAccess.components.forms);